import { createSvgIcon } from '@automata/mui-theme';
export const HettichSbs300Icon = createSvgIcon(
  <svg viewBox="0 0 96 96" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M80.5111 64.2902C80.8142 64.11 81 63.7834 81 63.4307V34.6175C81 34.2388 80.786 33.8925 80.4472 33.7231L79.5528 33.2759C79.214 33.1065 79 32.7603 79 32.3815V29.5725C79 29.2176 78.8119 28.8892 78.5057 28.7098L50.5066 12.2965C50.1938 12.1131 49.8063 12.1134 49.4939 12.2972L16.493 31.7095C16.1875 31.8892 16 32.2171 16 32.5715V35.5853C16 35.8505 15.8946 36.1049 15.7071 36.2924L14.2929 37.7066C14.1054 37.8942 14 38.1485 14 38.4137V67.9251C14 68.2808 14.1889 68.6097 14.4961 68.7889L43.4913 85.7028C43.8052 85.8859 44.1938 85.8843 44.5062 85.6985L80.5111 64.2902ZM17 66.7764V39.2422L17.8284 38.4137C18.5786 37.6636 19 36.6462 19 35.5853V33.7154L50.0026 15.4785L76 30.7184V32.3815C76 33.8163 76.7677 35.1345 78 35.8456V62.293L43.9854 82.5179L17 66.7764Z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M44.9999 56.0728L79.5053 35.8625L78.4945 34.1367L44.0014 54.3398L16.5076 38.1381L15.4922 39.8611L42.9999 56.071V83.4996H44.9999V56.0728Z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M57.2707 38.5668C62.5738 35.5053 62.5738 30.5416 57.2707 27.48C51.9675 24.4185 43.3695 24.4185 38.0663 27.48C32.7632 30.5416 32.7632 35.5053 38.0663 38.5668C43.3695 41.6284 51.9675 41.6284 57.2707 38.5668ZM59.0027 39.5668C65.2625 35.953 65.2625 30.0939 59.0027 26.4801C52.743 22.8663 42.594 22.8663 36.3342 26.4801C30.0745 30.0939 30.0745 35.953 36.3342 39.5668C42.594 43.1806 52.743 43.1806 59.0027 39.5668Z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M22 53.8676L38 63.4676V61.1324L22 51.5324V53.8676ZM20 49.7662V54.4338C20 54.7851 20.1843 55.1106 20.4855 55.2913L38.4855 66.0913C39.152 66.4912 40 66.0111 40 65.2338V60.5662C40 60.2149 39.8157 59.8894 39.5145 59.7087L21.5145 48.9087C20.848 48.5088 20 48.9889 20 49.7662Z"
    />
  </svg>,
  'HettichSbs300Icon'
);
